import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Auth } from 'aws-amplify';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  changePasswordForm: FormGroup;
  changePasswordLoading: boolean;
  changePasswordError: string;

  changeAvatarForm: FormGroup;
  changeAvatarLoading: boolean;
  changeAvatarError: string;
  changeAvatarInitializing: boolean = true;

  get password() { return this.changePasswordForm.get('password'); }
  get newPassword() { return this.changePasswordForm.get('newPassword'); }
  get confirmNewPassword() { return this.changePasswordForm.get('confirmNewPassword'); }

  get avatar() { return this.changeAvatarForm.get('avatarURL'); }
  
  constructor(
    private formBuilder: FormBuilder, 
    private snackbar: MatSnackBar,
    private authenticator: AuthenticatorService) { 
    this.changePasswordForm = this.formBuilder.group({
      password: this.formBuilder.control('', [
        Validators.required
      ]),
      newPassword: this.formBuilder.control('', [
        Validators.required,
        Validators.minLength(8)
      ]),
      confirmNewPassword: this.formBuilder.control('', [
        Validators.required
      ])
    }, {
      validator: passwordMatchValidator
    })
    this.changePasswordLoading = false;

    this.changeAvatarForm = this.formBuilder.group({
      avatarURL: this.formBuilder.control(null, [
        Validators.pattern(environment.rpmAvatarUrlRegExp)
      ])
    })

  }

  initAvatar() {

    this.changeAvatarInitializing = true;
    Auth.currentAuthenticatedUser({
      bypassCache: true
    }).then(u => {
      this.changeAvatarForm.patchValue({
        'avatarURL': u.attributes['custom:RPMAvatarURL']
      })
      this.changeAvatarInitializing = false;
    })

  }

  ngOnInit(): void {
    this.initAvatar();
  }

  async changePassword() {

    this.changePasswordLoading = true;

    var password = this.changePasswordForm.value.password
    var newPassword = this.changePasswordForm.value.newPassword
    var confirmNewPassword = this.changePasswordForm.value.confirmNewPassword

    if (newPassword == confirmNewPassword){

      Auth.changePassword(this.authenticator.user, password, newPassword).then(r => {
        this.snackbar.open("Password Changed","OK",)
      }).catch(e => {
        if (e.code == "NotAuthorizedException") {
          alert("Password is incorrect")
        } else {
          alert("An unexpected error occured while changing your password")
        }
      }).then(() => this.changePasswordLoading = false)
    } else {
      this.changePasswordLoading = false;
    }

  }

  onNewPasswordInput() {
    if (this.changePasswordForm.hasError('passwordMismatch'))
      this.confirmNewPassword.setErrors([{'passwordMismatch': true}]);
    else
      this.confirmNewPassword.setErrors(null);
  }

  async changeAvatar() {

    this.changeAvatarForm.disable();
    this.changeAvatarLoading = true;

    var user = await Auth.currentAuthenticatedUser()
    var result = await Auth.updateUserAttributes(user, {
      "custom:RPMAvatarURL": this.changeAvatarForm.value.avatarURL || ""
    })

    if (result == "SUCCESS") {
      this.snackbar.open("Avatar Updated", "OK")
    } else {
      this.snackbar.open("An unexpected error occurred", "OK")
      this.initAvatar();
    }

    this.changeAvatarForm.enable();
    this.changeAvatarLoading = false;

  }

}

export const passwordMatchValidator: ValidatorFn = (formGroup: FormGroup): ValidationErrors | null => {
  if (formGroup.get('newPassword').value === formGroup.get('confirmNewPassword').value)
    return null;
  else
    return {passwordMismatch: true};
};